import { render, staticRenderFns } from "./trainingModulePageDashboardSingle5.vue?vue&type=template&id=72025cbe&scoped=true&"
import script from "./trainingModulePageDashboardSingle5.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageDashboardSingle5.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageDashboardSingle5.vue?vue&type=style&index=0&id=72025cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72025cbe",
  null
  
)

export default component.exports